<style lang="less" scoped>
  @import "../../../assets/css/table-list.css";
  @import "../report.less";
</style>
<style lang="less">
  .report{
    .ivu-table-border td:nth-child(5) .ivu-table-cell,
    .ivu-table-border td:nth-child(6) .ivu-table-cell{
      padding:0;
      p{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        padding:10px;
      }
    }
  }
</style>
<template>
  <div class="report">
    <h3 class="title">商铺报表</h3>
    <div class="margin-bottom-10" style="display: flex;align-items: center">
     <div >
       <AutoComplete
         v-model="d_ProjName_label"
         :data="d_ProjName_arr"
         @on-select="change_name"
         placeholder="请选择或者输入"
         style="width:200px"></AutoComplete>
       <Button type="primary" @click="pull_data" style="margin-left: 10px;">筛选</Button>
     </div>
      <Row style="flex: 1;text-align: center;font-size: 12px;">
        <Col span="6">总计空置面积:{{ (d_propInfo.TotNullArea).toFixed(2) }}m²</Col>
        <Col span="6">总计空置率:{{ (Number(d_propInfo.TotNullRate)*100).toFixed(2) }}%</Col>
        <Col span="6">项目控制面积:{{ (d_propInfo.ProjNullArea).toFixed(2) }}m²</Col>
        <Col span="6">项目空置率: {{ (Number(d_propInfo.ProjNullRate)*100).toFixed(2) }}%</Col>
      </Row>
    </div>
    <section>
      <Table border :columns="d_columns" :data="d_data"></Table>
    </section>
  </div>
</template>
<script>
  import apiReport from '@/api/report.js';
  export default {
    name:'shopReport',
    data() {
      return {
        d_ProjName_label: '',
        d_ProjName_arr:[],
        d_columns: [
          {
            type: 'index',
            width: 60,
            align: 'left'
          },
          {
            title: '房屋坐落',
            align: 'center',
            key: 'address'
          },
          {
            title: '产权证号',
            align: 'center',
            key: 'PropNum'
          },
          {
            title: '产权面积',
            align: 'center',
            key: 'Area',
            render: (h, params) => {
              return h('span',params.row.Area+'m²')
            }
          },
          {
            title: '租赁合同面积',
            align: 'center',
            key: 'ContractArea',
            render: (h, params) => {
              let arr = params.row.ContractArea;
              return h('div',arr.map(function (item,index) {
                if(index===0){
                  return h('p', item+'m²')
                }else {
                  return h('p',{
                    style: {
                      borderTop:'solid 1px #e8eaec'
                    }
                  }, item+'m²')
                }
              }))
            }
          },
          {
            title: '备注',
            align: 'center',
            minWidth:120,
            key: 'Notes',
            render: (h, params) => {
              let arr = params.row.Notes;
              return h('div',arr.map(function (item,index) {
                if(index===0){
                  return h('p', item || '无备注')
                }else {
                  return h('p',{
                    style: {
                      borderTop:'solid 1px #e8eaec'
                    }
                  }, item || '无备注')
                }
              }))
            }
          },
          {
            title: '空置面积',
            align: 'center',
            key: 'NullArea',
            render: (h, params) => {
              return h('span',params.row.NullArea+'m²')
            }
          },
          {
            title: '空置率',
            align: 'center',
            key: 'NullRate',
            render: (h, params) => {
              return h('span',(Number(params.row.NullRate)*100).toFixed(2)+'%')
            }
          }
        ],
        d_data: [],
        d_propInfo:{
          Total:0, //总量
          ProjNullRate: 0, // 总计空置率
          TotNullArea:0, // 总计空置面积
          TotNullRate:0, // 总计空置率
          ProjNullArea:0, // 总计空置面积
        },

      };
    },
    methods: {
      change_name(value){ // 修改商铺报表
        this.d_ProjName_label = value;
      },
      get_ProjName(){
        let _this = this;
        apiReport.getProjNameList().then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.d_ProjName_arr = _data.data.Data;
            this.d_ProjName_label =  this.d_ProjName_arr[0];
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      pull_data() {
        let _this = this;
        let projName = this.d_ProjName_label;
        if(!projName) return;
        apiReport.GetReport1(projName).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let requestResult = _data.data.Data;
            let RowsList = requestResult.RowsList;

            this.d_propInfo = {
                Total: requestResult.TotArea,
                ProjNullRate: requestResult.ProjNullRate,
                TotNullArea: requestResult.TotNullArea,
                TotNullRate: requestResult.TotNullRate,
                ProjNullArea: requestResult.ProjNullArea,
            }
            let propNumArr = [];
            for(let i=0;i<RowsList.length;i++) {
              propNumArr.push(RowsList[i].PropNum);
            }
            let propNumsR = propNumArr.filter(function(element,index,self){ //去重
              return self.indexOf(element) === index;
            });
            let rowListR = []; // 重组后的数据
            for(let j=0;j<propNumsR.length;j++){
             let param = {
               ContractArea:[],
               Notes:[]
             };
              for(let i=0;i<RowsList.length;i++) {
                if(propNumsR[j] === RowsList[i].PropNum){
                  param.address = RowsList[i].City + RowsList[i].County + RowsList[i].Address;
                  param.PropNum = RowsList[i].PropNum;
                  param.Area = RowsList[i].Area;
                  param.ContractArea.push(RowsList[i].ContractArea);
                  param.Notes.push(RowsList[i].Notes);
                  param.NullArea = RowsList[i].NullArea;
                  param.NullRate = RowsList[i].NullRate;
                }
              }
              rowListR.push(param);
            }
            _this.d_data = rowListR;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      }
    },
    created() {
      this.get_ProjName();
    },

    mounted(){

    }
  }
</script>
